export default __webpack_public_path__ + "static/media/mazuma1.265a3863.jpg";